import { styled } from "@mui/material";
const Item = styled("div", {
  slot: "Root",
  name: "TruncateItem"
})`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export {
  Item
};
//# sourceMappingURL=Item.js.map
